import { convertBooleanMapToTotal } from '../../../../utils/model-progress.helper'
import baseApi from '../../base.api'
import { getQuestionById } from '../selectors/question.api.selectors'

export const onFetchQuestionProgressesQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    try {
        const { data } = await queryFulfilled
        if (data) {
            data.forEach(questionProgress => {
                dispatch(
                    baseApi.util.updateQueryData(
                        'fetchQuestions',
                        {
                            token: arg.token,
                            versionId: arg.versionId,
                        },
                        draft => {
                            const question = getQuestionById(draft, questionProgress.id)
                            if (question) {
                                question.processing = {
                                    progress: questionProgress.processing_progress,
                                    message: questionProgress.processing_msg,
                                    status: questionProgress.processing_status,
                                }
                            }
                        },
                    ),
                )
            })
        }
    } catch (error) {
        console.error('Error fetching question progresses:', error)
    }
}

export const onUpdateQuestionQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    try {
        await queryFulfilled
        dispatch(
            baseApi.util.updateQueryData(
                'fetchQuestions',
                {
                    token: arg.token,
                    versionId: arg.versionId,
                },
                draft => {
                    const question = getQuestionById(draft, arg.id)
                    if (question) Object.assign(question, arg)
                },
            ),
        )
        dispatch(
            baseApi.util.updateQueryData(
                'fetchProgress',
                {
                    token: arg.token,
                    versionId: arg.versionId,
                },
                draft => {
                    const questionDone = Boolean(arg.name.trim())

                    draft.originalModel.questions[arg.id] = questionDone
                    draft.questions = draft.originalModel.questions
                    draft.totalQuestions = convertBooleanMapToTotal(draft.originalModel.questions)
                },
            ),
        )
    } catch (error) {
        console.error('Error updating question:', error)
    }
}
